module.exports = __webpack_public_path__ + "static/media/FORTI.f78d47bb.png";